'use client';

import { LngLat } from '@yandex/ymaps3-types';
import { YMapLocationRequest } from '@yandex/ymaps3-types/imperative/YMap';
import {
  Feature as ClustererFeature,
  IClusterMethod
} from '@yandex/ymaps3-types/packages/clusterer';

import { ReactifyApi, Ymaps3Clusterer } from '@/fo/ui/mod/yandex/maps';

import { MARGIN, MOBILE_MARGIN } from '../../consts';
import { DoctorFeature } from '../../types';
import { Cluster } from '../Cluster/Cluster';
import { Marker } from '../Marker/Marker';

import { styles } from './MapContent.styles';

interface MapContentProps {
  reactifyApi: ReactifyApi;
  clusterer: Ymaps3Clusterer;
  gridSizedMethod: IClusterMethod;
  markers: DoctorFeature[];
  selectedPoint: DoctorFeature | null;
  location: YMapLocationRequest;
  isDesktop: boolean;
  onMarkerClick: (feature: DoctorFeature) => void;
  onClusterClick: (features: ClustererFeature[]) => void;
  onMapClick?: () => void;
  mode: 'profile' | 'search';
  children?: React.ReactNode;
}

export function MapContent({
  reactifyApi: {
    YMap,
    YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer,
    YMapMarker
  },
  clusterer: { YMapClusterer },
  gridSizedMethod,
  markers,
  selectedPoint,
  location,
  isDesktop,
  onMarkerClick,
  onClusterClick,
  onMapClick,
  mode = 'search',
  children
}: MapContentProps) {
  const slots = styles();

  const renderMarker = (feature: ClustererFeature) => (
    <YMapMarker coordinates={feature.geometry.coordinates as LngLat}>
      <Marker
        feature={feature as DoctorFeature}
        onClick={onMarkerClick}
        isSelected={selectedPoint?.id === feature.id}
        mode={mode}
      />
    </YMapMarker>
  );

  const renderCluster = (coordinates: LngLat, features: ClustererFeature[]) => (
    <YMapMarker coordinates={coordinates}>
      <Cluster
        features={features}
        onClick={onClusterClick}
      />
    </YMapMarker>
  );

  return (
    <div
      className={slots.base()}
      onClick={onMapClick}
    >
      <YMap
        location={location}
        margin={isDesktop ? MARGIN : MOBILE_MARGIN}
      >
        <YMapDefaultSchemeLayer />
        <YMapDefaultFeaturesLayer />
        <YMapClusterer
          features={markers}
          method={gridSizedMethod}
          marker={renderMarker}
          cluster={renderCluster}
          maxZoom={19}
        />
        {children}
      </YMap>
    </div>
  );
}
